import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const GreylistlistAreaDetailRBAC = {
  pageID: 'd53aa0e06d4f28ff641f070e5f149c0e',
  elementID: {
    ViewPage: '4ea08817716feee5b6805bcc69ac8f68',
    Delete: 'a43f4d67593fddc75dc3c8b92e1c04d7',
    Edit: '938b899bcd35a2323a0dac61bf1b0f12',
    Isochrone: 'ad38f2a8010f300b43c5d2efc8eb2243',
  },
} as const

export const useGreylistlistAreaDetailRBACPage = createUseRBAC(GreylistlistAreaDetailRBAC.elementID)

export type UseGreylistlistAreaDetailRBACPageType = ReturnType<
  typeof useGreylistlistAreaDetailRBACPage
>
